export const isTimeSame = (data: number) => {
  const internetTime = data // in Epoch
  const userTime = Math.floor(new Date().getTime() / 1000.0) //user need to restart browser for changes
  const allowedDifference = 60 // 1min
  if (Math.abs(internetTime - userTime) > allowedDifference) {
    return true
  }
  return false
}
